import {Form, Input, Select} from 'antd';
import {fieldRules} from 'utils/helper';
import styles from '../rewardSchemeTabs/newRewardSchemes.module.scss';

export const CashRewardConfig = ({hasReward, walletCurrencies}) => {
  if (!hasReward) {
    return null;
  }

  return (
    <div className={styles.configSection}>
      <div className={styles.sectionHeader}>
        <h1>Cash Reward Configuration</h1>
      </div>
      <div className={styles['date-format']}>
        <Form.Item
          label="Amount"
          className={styles.field}
          name="amount"
          rules={[fieldRules('amount is required')]}>
          <Input type="number" min={0} />
        </Form.Item>
        <Form.Item
          label="Currency"
          className={styles.field}
          name="cashCurrency"
          rules={[fieldRules('currency is required')]}>
          <Select allowClear>
            {walletCurrencies.map(({key, name}) => (
              <Select.Option value={key} key={key}>
                {name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </div>
  );
};
